import axios from 'axios';

export default axios.create({
	baseURL: process.env.VUE_APP_API_ROOT,
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${localStorage.authKey || sessionStorage.authKey}`,
	},
});

// Return function so it's dynamic.
// If this is loaded on the login screen before authKey is set, then it will fail
export const dynamic = function () {
	return axios.create({
		baseURL: process.env.VUE_APP_API_ROOT,
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${localStorage.authKey || sessionStorage.authKey}`,
		},
	});
};
